import logo from '../../img/saldivarLogo.png';
import imagen1 from '../../img/imagen1.jpg';
import imagen17 from '../../img/imagen17.jpg';
import imagen18 from '../../img/imagen18.jpg';

export const servicios = [
    {
        id: 1,
        titulo: 'Servicio dedicado',
        descripcion: 'Nos adecuamos a las necesidades de nuestros clientes cumpliendo con todas las medidas de seguridad y calidad. Ofrecemos servicio de unidades dedicadas de cruce, movimientos locales y rutas foráneas.',
        imagen: logo,
    },
    {
        id: 2,
        titulo: 'Foraneo nacional caja seca',
        descripcion: 'Ofrecemos servicios de Foráneo Nacional en unidades de caja seca de 1.5, 3.5 y 5 toneladas. Ofrecemos servicio dedicado y expedito hot shot.',
        imagen: imagen17,
    },
    {
        id: 3,
        titulo: 'Foraneo nacional caja refrigerada',
        descripcion: 'Ofrecemos servicios de Foráneo Nacional en unidades de caja refrigerada de 1.5, 3.5 y 5 toneladas. Contamos con unidades. Ofrecemos servicio dedicado y expedito hot shot.',
        imagen: imagen18,
    },
    {
        id: 4,
        titulo: 'Foraneo nacional plataforma',
        descripcion: 'Ofrecemos servicios de Foráneo Nacional en unidades de plataforma de 1.5 toneladas. Ofrecemos servicio dedicado y expedito hot shot.',
        imagen: imagen1,
    },
];
